export interface IProject {
    code: string;
    nameRu: string;
    nameKk: string;
    abp: string;
    prg: string;
    dateFromForInput: Date;
    dateToForInput: Date;
    budgetRegion: string;
    location: string[];
    budgetAmount: number;
    srcFundingDetail?: string[];
    budgetAmountRep: number;
    budgetAmountLocal: number;
    budgetAmountLoan: number;
    budgetAmountExtra: number;
    budgetAmountNf: number;
    srcData?: string;
    srcFunding?: string;
    projectStatus: "active" | "archived";
    projectBranch?: string;
    projectConcept?: string[];
    actDate: Date | null;
    plan?: Array<{ year: number; value: number }>; // Плановые значения: год и значение
    goals?: IGoal[];
    period_start_year: number;
    period_end_year: number;
    montajAct: string;
    expertCost: number;
    feoNum: string;
    feoDate: Date | null;
}

export interface IConcept {
    code: string;
    name_ru: string;
}

export interface ILocation {
    code: string;
    name: string;
}

export interface ITaskValue {
    year: number;
    value: number;
}

export interface ITask {
    id: number;
    name_ru: string;
    name_kz: string;
    values: ITaskValue[];
}

export interface IResultValue {
    year: number;
    value: number;
}

export interface IUnit {
    id: number;
    code: string;
    code_isgp: string;
    name_ru: string;
    name_kz: string;
    text: string;
}

export interface IGoalIndicator {
    id: number;
    code: string;
    name_ru: string;
    name_kz: string;
}

export interface IResult {
    id: number;
    type: number;
    name_ru: string;
    name_kz: string;
    indicator?: number | IGoalIndicator;
    indicator_ru?: string;
    indicator_kz?: string;
    unit?: number | IUnit;
    values: IResultValue[];
}

export interface IGoal {
    id: number;
    name_ru: string;
    name_kz: string;
    tasks: ITask[];
    results: IResult[];
}

export abstract class BaseProject implements IProject {
    public id = 0;
    public code = "";
    public nameRu = "";
    public nameKk = "";
    public abp = "";
    public prg = "";
    public dateFromForInput = new Date();
    public dateToForInput = new Date();
    public budgetRegion = "";
    public location: string[] = [];
    public budgetAmount = 0;
    public srcFundingDetail: string[] = [];
    public budgetAmountRep = 0;
    public budgetAmountLocal = 0;
    public budgetAmountLoan = 0;
    public budgetAmountExtra = 0;
    public budgetAmountNf = 0;
    public srcData = "";
    public projectStatus: "active" | "archived" = "active";
    public srcFunding = "";
    public projectBranch = "";
    public projectConcept: string[] = [];
    public actDate: Date | null = null;
    public plan: Array<{ year: number; value: number }> = [];
    public goals: IGoal[] = [];
    public period_start_year = new Date().getFullYear();
    public period_end_year = new Date().getFullYear();
    public montajAct = "";
    public expertCost = 0;
    public feoNum = "";
    public feoDate: Date | null = null;

    constructor(codePrefix: string) {
        this.code = `${codePrefix}-00000`;
    }
}

export class GipDataClass extends BaseProject {
    constructor() {
        super("GIP");
    }
}
export class CurProjectDataClass extends BaseProject {
    public srcData = "current";
    constructor() {
        super("CE");
    }
}

export interface ValidationErrors {
    [key: string]: string | undefined;
}

export type KatoItem = { code: string; name: string };
